export default [
  {
    path: "/ai/resume",
    name: "AiResume",
    component: () =>
      import(/* webpackChunkName: "account" */ "@/views/ai/resume"),
  },
  {
    path: "/ai/resume/:token/preview",
    name: "AiResumePreview",
    component: () =>
      import(/* webpackChunkName: "account" */ "@/views/ai/preview"),
  },
];
